export default {
  appliesToAllReports: 'Applies to all reports',
};
